import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MAT_DATE_LOCALE,MAT_DATE_FORMATS,DateAdapter } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrManager } from 'ng6-toastr-notifications';
import { JwtService } from '../../../../../../shared/services/jwt.service';
import { JwtUserModel } from '../../../../../../shared/models/jwt-user.model';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CargoLaboralService } from '../../../_core/services/cargolaboral.service';

@Component({
  selector: 'm-add-edit-cargo-laboral',
  templateUrl: './add-edit-cargo-laboral.component.html',
  styleUrls: ['./add-edit-cargo-laboral.component.scss']
})
export class AddEditCargoLaboralComponent implements OnInit {
  viewLoading: boolean = false;
	usuario: string;
  jwtUser: JwtUserModel;

  constructor(
    public dialogRef: MatDialogRef<AddEditCargoLaboralComponent>,
    private _formBuilder_lote: FormBuilder,
    public cargo_s: CargoLaboralService,
    private jwtService: JwtService,
    public toastr: ToastrManager,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.jwtUser = this.jwtService.getUser();
    this.create_form();
    this.getCargoTrabajador_cbo();
    this.getGerencia_cbo();
    this.getArea_cbo();
    if(this.data.item!=null){
      this.posible_TipoPago = this.data.item.Valor1;
      this.formMACRO.controls.Codigo.setValue(this.data.item.Valor);
      this.formMACRO.controls.Nombre.setValue(this.data.item.Nombre);
      this.formMACRO.controls.Descripcion.setValue(this.data.item.Descripcion);
      this.formMACRO.controls.Gerencia.setValue(this.data.item.Gerencia);
      this.formMACRO.controls.Area.setValue(this.data.item.Area);
      this.formMACRO.controls.CodNisira.setValue(this.data.item.Nisira);
      this.formMACRO.controls.Remuneracion.setValue(this.data.item.Sueldo);
      this.formMACRO.controls.Superior.setValue(this.data.item.RespondeA);
    }else{
      this.listCargos();
    }
  }

  //#region COMBOS
  protected _onDestroy = new Subject<void>();
  posible_TipoPago=null;
  public filterTipoPago: FormControl = new FormControl();
  public filtered_TipoPago: ReplaySubject<any> = new ReplaySubject<any>(); 
  array_TipoPago: Array<any> = [];
  public filterCargoTrabajador: FormControl = new FormControl();
  public filtered_CargoTrabajador: ReplaySubject<any> = new ReplaySubject<any>(); 
  array_CargoTrabajador: Array<any> = [];
  public filterArea: FormControl = new FormControl();
  public filtered_Area: ReplaySubject<any> = new ReplaySubject<any>(); 
  array_Area: Array<any> = [];
  public filterGerencia: FormControl = new FormControl();
  public filtered_Gerencia: ReplaySubject<any> = new ReplaySubject<any>(); 
  array_Gerencia: Array<any> = [];

  getTipoPago_cbo(){
    this.cargo_s.getTipoPagoList().subscribe(
      (data: any) => {
        data=data.filter(e=>e.Activo==true);
        this.array_TipoPago = data;
        this.filtered_TipoPago.next(this.array_TipoPago.slice());
        this.filterTipoPago.valueChanges.pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtrar_TipoPago();
          }
        );
        this.formMACRO.controls.TipoPagoContrato.setValue(this.posible_TipoPago);
      }, ( errorServicio ) => {
        console.log(errorServicio);
      }
    );
  }

  filtrar_TipoPago(){
    if (this.array_TipoPago.length==0) {
      return;
    }
    let search = this.filterTipoPago.value;
    if (!search) {
      this.filtered_TipoPago.next(this.array_TipoPago.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtered_TipoPago.next(
      this.array_TipoPago.filter(item => item.Nombre.toLowerCase().indexOf(search) > -1)
    );
  }

  getCargoTrabajador_cbo(){
    this.cargo_s.getCargoTrabajadorList().subscribe(
      (data: any) => {
        data=data.filter(e=>e.Activo==true);
        this.array_CargoTrabajador = data;
        this.filtered_CargoTrabajador.next(this.array_CargoTrabajador.slice());
        this.filterCargoTrabajador.valueChanges.pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtrar_CargoTrabajador();
          }
        );
        //this.formMACRO.controls.TipoPagoContrato.setValue(this.posible_TipoPago);
      }, ( errorServicio ) => {
        console.log(errorServicio);
      }
    );
  }

  filtrar_CargoTrabajador(){
    if (this.array_CargoTrabajador.length==0) {
      return;
    }
    let search = this.filterCargoTrabajador.value;
    if (!search) {
      this.filtered_CargoTrabajador.next(this.array_CargoTrabajador.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtered_CargoTrabajador.next(
      this.array_CargoTrabajador.filter(item => item.Nombre.toLowerCase().indexOf(search) > -1)
    );
  }

  getGerencia_cbo(){
    this.cargo_s.ListarGerencia().subscribe(
      (data: any) => {
        this.array_Gerencia = data;
        this.filtered_Gerencia.next(this.array_Gerencia.slice());
        this.filterGerencia.valueChanges.pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtrar_Gerencia();
          }
        );
      }, ( errorServicio ) => {
        console.log(errorServicio);
      }
    );
  }

  filtrar_Gerencia(){
    if (this.array_Gerencia.length==0) {
      return;
    }
    let search = this.filterGerencia.value;
    if (!search) {
      this.filtered_Gerencia.next(this.array_Gerencia.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtered_Gerencia.next(
      this.array_Gerencia.filter(item => item.Nombre.toLowerCase().indexOf(search) > -1)
    );
  }

  getArea_cbo(){
    this.cargo_s.ListarArea().subscribe(
      (data: any) => {
        this.array_Area = data;
        this.filtered_Area.next(this.array_Area.slice());
        this.filterArea.valueChanges.pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtrar_Area();
          }
        );
      }, ( errorServicio ) => {
        console.log(errorServicio);
      }
    );
  }

  filtrar_Area(){
    if (this.array_Area.length==0) {
      return;
    }
    let search = this.filterArea.value;
    if (!search) {
      this.filtered_Area.next(this.array_Area.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filtered_Area.next(
      this.array_Area.filter(item => item.Nombre.toLowerCase().indexOf(search) > -1)
    );
  }

  listCargos(){
    this.cargo_s.getCargoTrabajadorList()
      .subscribe( (response:Array<any>) => {
        if(response.length){
          let maxCodigo:any = '0000';
          response.forEach(e => {
            if(e.Codigo > maxCodigo){
              maxCodigo = e.Codigo;
            }
          });
          const cod:any = Number(maxCodigo);
          this.formMACRO.controls['Codigo'].setValue(this._zfill(cod + 1,4).toString());
        }
      })
  }

  //#endregion
  save_update(){
    const _controls = this.formMACRO.controls; 
      if (this.formMACRO.invalid) {
        Object.keys(_controls).forEach(controlName =>
          _controls[controlName].markAsTouched()
        );
        this.toastr.warningToastr('Ingrese los campos obligatorios.', 'Advertencia!', {
          toastTimeout: 2000,
          showCloseButton: true,
          animate: 'fade',
          progressBar: true
        });
      }else{
        this.viewLoading = true;
        let model = {
          Codigo: _controls.Codigo.value,
          Nombre: _controls.Nombre.value,
          Descripcion: _controls.Descripcion.value,
          Gerencia: _controls.Gerencia.value,
          Area: _controls.Area.value,
          CodNisira: _controls.CodNisira.value,
          Remuneracion: _controls.Remuneracion.value,
          Superior: _controls.Superior.value,
        };
        
        this.cargo_s.saveUpdateCargoTrabajador(model).subscribe(
          (data: any) => {
            if(data[0].Status){
              this.toastr.successToastr(data[0].Msg, 'Éxito!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });
            }else{
              this.toastr.warningToastr(data[0].Msg, 'Advertencia!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });
            }
            this.viewLoading = false;
            this.dialogRef.close(true);
          }, ( errorServicio ) => {
            this.toastr.errorToastr(errorServicio.message, 'Error!', {
              toastTimeout: 2000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
            this.viewLoading = false;
            console.log(errorServicio);
          }
        );
          
      }
      return;
  }

  formMACRO: FormGroup;
  create_form(){
    this.formMACRO = this._formBuilder_lote.group({
      //TipoPagoContrato: [null],
      Codigo: [{value:null,disabled:true}], 
      Nombre: [null, Validators.required],
      Descripcion: [null],
      Area: [null, Validators.required],
      Gerencia: [null, Validators.required],
      CodNisira: [null, Validators.required],
      Remuneracion: [null,  Validators.pattern(/^([0-9]+\.?[0-9]{0,2})$/)],
      Superior: [null],
    });
  }

  onNoClick(): void {
		this.dialogRef.close();
  }

  onYesClick() {
    this.viewLoading = true;
    this.dialogRef.close(true);
  }

  _zfill(number:number, width:number) {
    var numberOutput = Math.abs(number);
    var length = number.toString().length;
    var zero = "0";
    
    if (width <= length) {
        if (number < 0) {
             return ("-" + numberOutput.toString()); 
        } else {
             return numberOutput.toString(); 
        }
    } else {
        if (number < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
        } else {
            return ((zero.repeat(width - length)) + numberOutput.toString()); 
        }
    }
  }

}